import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBT2BeLRvUfy5a-A7hLVw24uEw1Zne8e04",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "oberoi-e074f.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "oberoi-e074f",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "oberoi-e074f.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "859239829244",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:859239829244:web:3b040407c407dce5b71179",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-08TLGHMXJK"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);